<template>
<div>

		<app-section-loader :status="loader"></app-section-loader>


  <v-layout row>
        <v-flex sm2>
        <dx-button text="+ Menu" @click="addMenu" />
        </v-flex>
        <v-flex sm3>
          <dx-text-box v-model="txtMenu" placeholder="Omschrijving menu..."></dx-text-box>
        </v-flex>
  </v-layout>

  <dx-data-grid
    :name="getBaseName"
    :show-borders="true"
    :data-source="getData"
    :no-data-text="noData"
    key-expr="ID"
    :show-column-headers="true"
  >
    <dx-column
      :width="withMenu"
      data-field="Descr"
      caption="Menu"
    />

    <dx-column
      :width="80"
      data-field="NumOrder"
      caption="Volgorde"
    />
    
     <dx-column
        :width="90"
        :buttons="editButtons"
        type="buttons"
      />


    <dx-master-detail
      :enabled="true"
      template="masterDetailTemplate"
    />

     <div
      slot="masterDetailTemplate"
      slot-scope="record"
    >
      <online-struct-det  name="onlinedetail"  :isChild="isChildItem"
        :template-data="record"  @refreshControl="refreshControlEvt"
      />
    </div>

  </dx-data-grid>

  <dx-popup
      :visible.sync="popupModify"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :width="300"
      :height="270"
      class="popup"
      title="Menu aanpassen"
    >
    
     <v-layout row>
        <v-flex sm12>
        Menu omschrijving
        <dx-text-box v-model="txtMenuMod" placeholder="Omschrijving menu..."></dx-text-box>
        </v-flex>
    </v-layout>
    <v-layout row><v-flex sm12>&nbsp;</v-flex></v-layout>
    <v-layout row>
        <v-flex sm6>
        Volgorde: <dx-number-box v-model="numOrder" placeholder="0" mask="99"></dx-number-box>
        </v-flex>
    </v-layout>
    <v-layout row><v-flex sm12>&nbsp;</v-flex></v-layout>
     <v-layout row>
        <v-flex sm12>
        <dx-button text="Bewaar" @click="saveMenu" />
        </v-flex>
    </v-layout>
    
     
    </dx-popup>

  </div>

</template>
<script>

import myHttpApi from "../../api/myHttpApi";
import { DxDataGrid, DxColumn, DxMasterDetail } from 'devextreme-vue/data-grid';
import OnlineStructDet from "../../views/onlinereservation/OnlineStructDetail.vue";
import { DxButton, DxPopup, DxToolbar, DxTextBox, DxNumberBox } from 'devextreme-vue';
import { confirm } from 'devextreme/ui/dialog';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxMasterDetail,
    OnlineStructDet,
    DxButton,
    DxPopup,
    DxToolbar,
    DxTextBox,
    DxNumberBox
  },
  props: ['childs', 'isChild', 'menuid'],
  data() {
    return {
      dataSource: [],
      autoExpandAll: true,
      isChildItem : false,
      withMenu : 650,
      baseName : 'ctlRootMenu',
      cntRows : 0,
      popupModify : false,
      loader: true,
      txtMenu : '',
      txtMenuMod : '',
      numOrder : 0,
      currentRec : {},
      editButtons: [ 
        {hint: 'Wijzig',icon: 'edit', onClick: this.onModifyClicked},
        {hint: 'Wis',icon: 'remove', onClick: this.onDeleteClicked}
        
      ],
    };
  },
   mounted() {
	//this.dateMonth =  this.getDate (new Date()); 
    this.getRemoteData();
  },
 
  computed: {
     noData () {
       return ("Geen submenu's");
     },
     getData () {

        // console.log (this.childs);
        if (this.childs != undefined)
        {
            console.log ("loading childs");
            this.withMenu = 475;
            this.isChildItem = true;
            this.cntRows = this.cntRows + 1;
            this.ctlRootMenu = 'ctlRootMenuSub' + this.cntRows;
            return this.getFilteredCatList (this.childs);
        }
        else
        {
            this.cntRows = 0;
            this.withMenu = 650;
            this.isChildItem = false;
            this.ctlRootMenu = 'ctlRootMenu';
            return this.dataSource;
        }
     },
     getBaseName () {
         return  this.ctlRootMenu;
     },
  },
  methods: {
    getFilteredCatList (list) {

       var childList = [];

       if (list == undefined) return childList;

        for (var c = 0; c < list.length; c++)
        {
            if (list[c].KindRec == 0)  //CAT
            {
               childList.push (list[c]);
               for (var d = 0; d < list[c].Childs.length; d++)
                {
                    if (list[c].Childs[d].KindRec == 0)
                    {
                      list[c].Childs.push (list[d]);
                    }
                }
            }
        }
        return childList;
    },
    refreshControlEvt (item) {
       //console.log ("refreshing control...");
       this.$emit('refreshControlRoot', '');
       this.getRemoteData();
    },
    getRemoteData() {
			myHttpApi
      
    this.loader = true;
    this.dataSource = [];

		myHttpApi.post('BOSettings/GetMenuOnline', "")
        .then(response => {
            this.loader = false;
            this.dataSource = response.data;
            for (var c = 0; c < this.dataSource.length; c++)
            {
                console.log (this.dataSource[c]  + "==" + this.menuid);
                if (this.dataSource[c].ID == this.menuid)
                {
                    this.childs = this.dataSource[c].Childs;
                    break;
                }
            }
            
        })
        .catch(error => {
          console.log(error);
          this.loader = false;
        });
    },
    addMenu ()  {

        myHttpApi

        if (this.txtMenu.length < 2)
        {
           alert ('Menu omschrijving verplicht');
           return;
        }
        
      
        const searchRec = {Descr: this.txtMenu, ParentID : this.menuid}
        myHttpApi.post('BOSettings/AddMenuOnline', searchRec)
            .then(response => {
                this.dataSource = response.data;
                this.getRemoteData();
                this.txtMenuMod = "";
            })
            .catch(error => {
              console.log(error);
            });

    },
    saveMenu () {
        myHttpApi
        
        if (this.txtMenuMod.length < 2)
        {
           alert ('Menu omschrijving verplicht');
           return;
        }
        
        this.popupModify = false;

        this.currentRec.Descr = this.txtMenuMod;

        //var thenum = this.txtOrder.match(/\d+$/)[0];
        this.currentRec.NumOrder = this.numOrder;

        myHttpApi.post('BOSettings/SaveMenuOnline', this.currentRec)
            .then(response => {
                this.dataSource = response.data;
                this.getRemoteData();
                
            })
            .catch(error => {
              console.log(error);
            });
    },
    onDeleteClicked (item) {
       
       myHttpApi

       //this.popupDelete = true;
       let result = confirm("Menu <strong>" + item.row.data.Descr + "</strong> verwijderen.<br><br><i>Ben je zeker?</i>", "Menu verwijderen");
            result.then((dialogResult) => {
                //alert(dialogResult ? "Confirmed" : "Canceled");
                if (dialogResult == true)
                {
                  
                  const searchRec = {ID : item.row.data.ID}
                  myHttpApi.post('BOSettings/DelMenuOnline', searchRec)
                      .then(response => {
                          this.dataSource = response.data;
                          this.getRemoteData();
                        
                      })
                      .catch(error => {
                        console.log(error);
                      });

                }
            });
    },
    onModifyClicked (item) {
       //console.log (item);
       this.txtMenuMod = item.row.data.Descr;
       this.numOrder = item.row.data.NumOrder;
       //console.log (this.txtMenuMod + "  " + this.numOrder);
       this.currentRec = item.row.data;
       this.popupModify = true;
    }
  }
};
</script>